import {
	ASSET_ALL_GET,
	ASSET_SET_SELECTED,
	ASSET_SET_FAVORITE,
	ASSET_SO_ID_LIST_SET,
	ASSETS_CURRENT_LIST_SET,
	ASSETS_SET_CURRENT_TAB,
	ASSETS_UPDATE_BY_SOCKETS,
	LOT_SIZES_GET,
	TRADE_SIZES_GET,
	ASSET_SET_SEARCH,
	ASSET_SET_SINGLE,
	ASSET_TRADING_HOURS_GET,
	ASSET_ONLY_FAVORITE_SET,
	ASSET_MUTED_SET,
	LATEST_RATES_ITEM_SET, UPDATE_TRADE_LOT_SIZES
} from './actions'
import { initialLatestRates } from '../../../config'
import { getIsMonday, getNearestStart } from '../../../helpers'

const initialState = {
	activeHoursArr: {},
	assetSearchString: '',
	assetSingle: null,
	assetsAll: {},
	assetsSoIdesAll: {},
	assetsToSockets: [],
	classAssetsTypes: 'currencies,commodities,indices,stocks,usd,crypto_eur,bitcoin,ethereum',
	classAssetsTypesDefault: 'currencies,commodities,indices,stocks,usd,crypto_eur',
	currentAssetInfo: false,
	currentAssetsTab: '',
	defaultAssets: [],
	latestRates: initialLatestRates,
	latestRatesBidAsk: {},
	lotSizes: {},
	mutedAssets: [],
	onlyFavorite: false,
	refreshTarget: [],
	selectedAsset:  getIsMonday() ?
		{'assetSoId': 'asset_4121', 'assetType': 'usd' } :
		{'assetSoId': 'asset_35', 'assetType': 'currencies' },
	selectedAssetTitle: getIsMonday() ? 'BTC/USDT ' : 'AUD/USD',
	tradeSizes: []
}

export default (state = initialState, action) => {
	switch (action.type) {
	case ASSET_ALL_GET: {
		const latestRatesBidAsk = {}
		let obj = action.payload.reduce((result, item) => {
			let key = item.type
			if (!result[key]) result[key] = {}
			latestRatesBidAsk['asset_' + item.soId] = {
				ask:  item.lastAsk,
				askUp: undefined,
				bid: item.lastBid,
				bidUp: undefined
			}
			result[key]['asset_' + item.soId] = {
				alias: item.alias,
				bookmarked: item.bookmarked,
				id: item.id,
				lotSize: item.lotSize,
				pipDecimalPlaces: item.pipDecimalPlaces,
				soId: item.soId,
				tailDigits: item.tailDigits,
				title: item.name,
				type: item.type
			}
			return result;
		}, {})
		let soIdes = []
		let soId
		for (soId in state.assetsAll[getIsMonday() ? 'usd' : 'currencies']) {
			soIdes.push(soId)
		}
		let lotSizes = {}
		let soIdesAll = {}
		let type
		for ( type in obj) {
			if (!soIdesAll[type]) soIdesAll[type] = []
			let key
			for (key in obj[type]){
				soIdesAll[type].push(key)
				lotSizes[obj[type][key].soId] = obj[type][key].lotSize
			}
		}
		return {
			...state,
			assetsAll: obj,
			assetsSoIdesAll: soIdesAll,
			assetsToSockets: soIdes,
			defaultAssets: action.payload,
			latestRatesBidAsk: latestRatesBidAsk,
			lotSizes: lotSizes
		}
	}

	case ASSETS_CURRENT_LIST_SET: {
		return {
			...state,
			currentAssetsList: state.assetsAll[action.payload]
		}
	}

	case ASSETS_UPDATE_BY_SOCKETS: {
		return {
			...state,
			latestRates: { ...state.latestRates, ...action.payload.newDataRates },
			latestRatesBidAsk: { ...state.latestRatesBidAsk, ...action.payload.newDataBidAsk }
		}
	}

	case ASSET_SET_FAVORITE: {
		let defaultAssets = state.defaultAssets.map(
			asset => action.payload.assetSoId === 'asset_' + asset.soId
				? {
					...asset,
					bookmarked: !asset.bookmarked
				}
				: asset
		)
		let current = {...state.assetsAll[action.payload.assetType][action.payload.assetSoId]}
		let assetNew = {[action.payload.assetSoId]: {...current, bookmarked: !current.bookmarked}}
		let typeNew = {[action.payload.assetType]: {...state.assetsAll[action.payload.assetType], ...assetNew}}
		return { ...state, assetsAll: { ...state.assetsAll, ...typeNew },  defaultAssets: defaultAssets}
	}

	case ASSET_SO_ID_LIST_SET: {
		let soIdes = []
		let soId
		for (soId in state.assetsAll[action.payload]) {
			soIdes.push(soId)
		}
		return {
			...state,
			assetsToSockets: soIdes
		}
	}

	case ASSET_SET_SELECTED: {
		localStorage.setItem('trading-selected-asset', JSON.stringify(action.payload))
		return {
			...state,
			selectedAsset: action.payload,
			selectedAssetTitle: state.assetsAll[action.payload.assetType][action.payload.assetSoId].title
		}
	}
	case ASSETS_SET_CURRENT_TAB: {
		return {
			...state,
			currentAssetsTab: action.payload
		}
	}

	case ASSET_ONLY_FAVORITE_SET: {
		return {
			...state,
			onlyFavorite: action.payload
		}
	}
	case LOT_SIZES_GET: {
		return {
			...state,
			lotSizes: {...state.lotSizes, ...action.payload}
		}
	}
	case TRADE_SIZES_GET: {
		return {
			...state,
			tradeSizes: action.payload
		}
	}

	case UPDATE_TRADE_LOT_SIZES: {
		return {
			...state,
			lotSizes: {...state.lotSizes, ...action.payload},
			tradeSizes: action.payload.tradeSizes
		}
	}
	
	case ASSET_SET_SEARCH: {
		return {
			...state,
			assetSearchString: action.payload
		}
	}
	case ASSET_SET_SINGLE: {
		return {
			...state,
			assetSingle: action.payload
		}
	}
	case ASSET_TRADING_HOURS_GET: {
		return {
			...state,
			activeHoursArr: action.payload
		}
	}
	case LATEST_RATES_ITEM_SET: {
		let assetSoId = action.payload.assetSoId
		let rates = action.payload.rates
		return {
			...state,
			latestRates: {...state.latestRates, [assetSoId]: rates}
		}
	}
	case ASSET_MUTED_SET: {
		let mutedAssets = []
		let activeHoursArr = {...state.activeHoursArr}
		let soId
		for (soId in action.payload) {
			let my_array = action.payload[soId]
			if(my_array=='none') {
				mutedAssets.push(soId)
				continue
			}
			let active = false;
			let currentTime = Math.round(new Date().getTime()/1000);
			if (!(activeHoursArr == null) && !(activeHoursArr[soId] == null)) {
				if (activeHoursArr[soId][0].startTime === null) {
					active = false
					// eslint-disable-next-line
					console.log('missing activity hours for ', soId)
				} else {
					for (let i = activeHoursArr[soId].length - 1; i >= 0; i--) {
						if ((activeHoursArr[soId][i]['startTime'] + 30) < currentTime &&
							(activeHoursArr[soId][i]['endTime'] - 30) > currentTime) {
							active = true
						}
					}
				}
			} else {
				// eslint-disable-next-line
				console.log('ops missing activity hours')
				active = true;
			}
			if (!(active)) {
				mutedAssets.push(soId);
			}
		}
		let newAssetsAll = {}
		let soIdesAll = {}
		if (!(Object.keys(state.assetsAll).length === 0)){
			const assets = {...state.assetsAll}
			const activeHours = {...state.activeHoursArr}
			let type
			for (type in assets) {
				if (!soIdesAll[type]) soIdesAll[type] = []
				let active = []
				let muted = []
				let key
				for(key in assets[type]) {
					if (!newAssetsAll[type]) newAssetsAll[type] = {}
					let asset = {...assets[type][key]}
					let soId = asset.soId
					asset.nearestStart = getNearestStart(activeHours[soId])
					if(mutedAssets.length && mutedAssets.find(item => soId === item)) {
						asset.muted = true
						muted.push(key)
					} else {
						asset.muted = false
						active.push(key)
					}
					soIdesAll[type] = active.concat(muted)
					newAssetsAll[type][key] = asset
				}
			}
		}
		return {
			...state,
			assetsAll: {...state.assetsAll, ...newAssetsAll},
			assetsSoIdesAll: soIdesAll,
			mutedAssets: mutedAssets
		}
	}
	default: {
		return state
	}
	}
}
